import { URL_CONFIG } from '@/configs/environment';
import { isPathEk } from '@/utils/routes';
import { Link, useLocation } from 'react-router-dom';
import LogoRental from '@/assets/images/logo-icon-rental.svg';
import { ekDomain } from '@/configs/constants';

import './style.scss';
import { cn, linkHomePage } from '@/utils/utils';

const Logo = () => {
    // hooks
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    return (
        <Link
            to={linkHomePage()}
            className='main-logo_wrap'
        >
            <span className='icon'><img src={LogoRental} alt='' /></span>
            <svg
                className='w-full fill-black block max-w-full'
                viewBox='0 0 158.286 28.754'
                aria-label='ベストBikeレンタル'
                role='img'
            >
                <use href={isEk ? '#kick-logo' : '#main-logo'}></use>
            </svg>
        </Link>
    );
};

const LogoCMS = ({ linkClassName = '' }) => {
    // hooks
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    return (
        <Link
            to={`${isEk ? `${URL_CONFIG.APP.url}/${ekDomain}` : `${URL_CONFIG.DOMAIN_WORDPRESS.url}`}`}
            className={cn(
                'main-logo_wrap',
                linkClassName
            )}
        >
            <span className='icon'><img src={LogoRental} alt='' /></span>
            <svg
                className='w-full fill-white block max-w-full'
                viewBox='0 0 158.286 28.754'
                aria-label='ベストBikeレンタル'
                role='img'
            >
                <use href={isEk ? '#kick-logo' : '#main-logo'}></use>
            </svg>
        </Link>
    );
};

export { Logo, LogoCMS };
